



import EventPreviewComponent from "@/components/admin/event/eventPreviewComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "EventPreviewPage",
  components: {
    EventPreviewComponent,
  },
})
export default class EventPreviewPage extends Vue {}
